import { NewRow } from 'components/molecules/new-row';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacNewRow = withAccess(NewRow);
